// Converts the first letter of each word to uppercase
export const toTitleCaseAdvanced = (str) => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  
  return str.replace(/\w\S*/g, (word) => {
    return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
  });
};

// Get greeting based on current time
export const getTimeBasedGreeting = () => {
  const currentHour = new Date().getHours();
  
  if (currentHour < 12) {
    return 'Good Morning';
  } else if (currentHour < 17) {
    return 'Good Afternoon';
  } else {
    return 'Good Evening';
  }
};

export const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) return '-';
  
  try {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}-${month}-${year}`;
  } catch (error) {
    return '-';
  }
};